export var POPPINS = '"Poppins", sans-serif';
export var OSWALD = '"Oswald", sans-serif';
export var PROXIMA_NOVA = '"Proxima Nova", sans-serif';
export var KARLA = '"Karla", sans-serif';
export var MULISH = '"Mulish", sans-serif';
export var BRANDON = '"Brandon Text", sans-serif';
export var BRANDON_BOLD = '"Brandon Text Bold", sans-serif';
export var URBANIST = '"Urbanist", sans-serif';
//# sourceMappingURL=fonts.js.map